var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.57576L13.0939 4.20644L13.1056 4.2137L13.5 3.57576ZM16 5.12121L16.4586 4.52775L16.4276 4.50383L16.3944 4.48327L16 5.12121ZM16.8343 5.76593L17.2929 5.17247L16.8343 5.76593ZM13.9061 2.94518L11.5588 1.43368L10.7467 2.69482L13.0939 4.20633L13.9061 2.94518ZM7.44839 1.46635L1.91987 5.15203L2.75192 6.4001L8.28044 2.71443L7.44839 1.46635ZM0.25 8.27222V14.5H1.75V8.27222H0.25ZM4.5 18.75H14.5V17.25H4.5V18.75ZM18.75 14.5V8.13978H17.25V14.5H18.75ZM17.2929 5.17247L16.4586 4.52775L15.5414 5.71468L16.3758 6.3594L17.2929 5.17247ZM13.1056 4.2137L15.6056 5.75916L16.3944 4.48327L13.8944 2.93781L13.1056 4.2137ZM18.75 8.13978C18.75 6.97842 18.2119 5.88258 17.2929 5.17247L16.3758 6.3594C16.9271 6.78546 17.25 7.44296 17.25 8.13978H18.75ZM14.5 18.75C16.8472 18.75 18.75 16.8472 18.75 14.5H17.25C17.25 16.0188 16.0188 17.25 14.5 17.25V18.75ZM0.25 14.5C0.25 16.8472 2.15279 18.75 4.5 18.75V17.25C2.98122 17.25 1.75 16.0188 1.75 14.5H0.25ZM1.91987 5.15203C0.87663 5.84753 0.25 7.01839 0.25 8.27222H1.75C1.75 7.51992 2.12598 6.8174 2.75192 6.4001L1.91987 5.15203ZM11.5588 1.43368C10.3042 0.625794 8.68998 0.638626 7.44839 1.46635L8.28044 2.71443C9.02539 2.21779 9.99391 2.21009 10.7467 2.69482L11.5588 1.43368Z",
    fill: "#8C8C8C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.75,
    y1: 14.25,
    x2: 11.25,
    y2: 14.25,
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a4ea3621d476ebe06ff4f60f1e886285.svg";
export { ForwardRef as ReactComponent };